<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import VueCookies from "vue-cookies";
// VueCookies.config("", "", "", true);

export default {
  name: 'App',
  components: {
  },
  async created() {
    // await this.$store.dispatch("fetchPermissions")
  }
}
</script>

<style>
#app {
  height: 100vh;
}
</style>
